import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table, Row, Col, Modal, Form } from 'react-bootstrap';
import RhService from '../../../../../services/rh';
import { useParams } from "react-router-dom";
import Holerite from './holerite';
import FormBusca from './busca';
import '../../../../../styles/diario.scss'


const HoleritesScreen = () => {

    const [holerites, setHolerites] = useState([]);
    const [nome, setNome] = useState("");
    const [holeritesOriginais, setHoleritesOriginais] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
    const [anosDisponiveis, setAnosDisponiveis] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({ funcId: null, holId: null });
    const { id } = useParams();


    const abrirModalEdicao = (funcId, holId) => {
        setEditData({ funcId, holId });
        setShowModal(true);
    };

    const deletar = async (funcId, holId) => {
        try {
            const del = await RhService.limparFuncionario(funcId, holId);
            if (del.ok) {
                alert(del.mensagem)
                fetchHolerites()
            }
        } catch (err) {
            alert(err)
        }

    }

    const fecharModal = () => setShowModal(false);

    const enviarNovaHolerite = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("arquivo", e.target.arquivo.files[0]);
        formData.append('funcionario', editData.funcId);
        formData.append('holerite', editData.holId);

        try {
            await RhService.trocaHolerite(formData);
            alert("Holerite substituída com sucesso!");
            setShowModal(false);
            fetchHolerites();
        } catch (err) {
            alert("Erro ao atualizar holerite");
        }
    };

    async function fetchHolerites() {
        const response = await RhService.holerites(id);
        if (response.data["holerites"].length >= 1) {

            const lista = response.data["holerites"];
            setNome(response.data["nome"]);
            setHolerites(lista);
            setHoleritesOriginais(lista);

            // obtém meses únicos
            const meses = [...new Set(lista.map(h => h.mes))].sort((a, b) => a - b);
            setMesesDisponiveis(meses);

            // obtém anos únicos
            const anos = [...new Set(lista.map(h => h.ano))].sort((a, b) => a - b);
            setAnosDisponiveis(anos);

            setVazio(false);

        } else {
            setHolerites([]);
            setHoleritesOriginais([]);
            setMesesDisponiveis([]);
            setAnosDisponiveis([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (mes, ano) => {
        let filtrados = holeritesOriginais;

        if (mes) filtrados = filtrados.filter(h => h.mes == mes);
        if (ano) filtrados = filtrados.filter(h => h.ano == ano);

        if (filtrados.length >= 1) {
            setHolerites(filtrados);
            setVazio(false);
        } else {
            setHolerites([]);
            setVazio(true);
        }
    };

    useEffect(() => {
        fetchHolerites();
    }, []);


    return (
        <Fragment>
            <Container>
                <Row xs={12}>
                    <Col>
                        <h5>Holerites do funcionário: <strong>{nome}</strong></h5>
                        <br />
                    </Col>
                </Row>
                <Fragment>
                    <FormBusca
                        meses={mesesDisponiveis}
                        anos={anosDisponiveis}
                        filtrarLocalmente={filtrarLocalmente}
                        reset={() => { setHolerites(holeritesOriginais); setVazio(false); }}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Row xs={12}>
                        <Col>
                            <br />
                            <Alert variant='danger'>Não localizamos nenhuma holerite referente ao período :(</Alert>
                        </Col>
                    </Row>
                </Fragment> :
                    <Fragment>
                        <br />
                        <Table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Mês/Ano</th>
                                    <th>Holerite</th>
                                    <th>Trocar Holerite</th>
                                    <th>Apagar Holerite</th>
                                </tr>
                            </thead>
                            <tbody>
                                {holerites.map((holerite, index) =>
                                    <Holerite
                                        holerite={holerite}
                                        key={index}
                                        funcId={id}
                                        editar={abrirModalEdicao}
                                        deletar={deletar}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Fragment>}
                {showModal && (
                    <Modal show={showModal} onHide={fecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Substituir Holerite</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form onSubmit={enviarNovaHolerite}>
                                <div className="mb-3">
                                    <label className="form-label">Selecione o novo PDF</label>
                                    <input type="file" name="arquivo" className="form-control" accept="application/pdf" required />
                                </div>

                                <button className="btn btn-primary" type="submit">Salvar</button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                )}
            </Container>
        </Fragment>

    )
}

export default HoleritesScreen;